export const INVALID_ROUTE_OFFLINE_MESSAGE =
  "この画面はオフラインモードでは使用できません";
